import { Center, createStyles, Group, Text, Title } from "@mantine/core";
import logo from "../assets/logo512.png"

const useStyles = createStyles(() => ({
    logo: {
        height: "2.6vh",
        marginLeft: "1vw"
    }
}))

export function Footer() {
    const { classes } = useStyles()
    return <div style={{ position: "fixed", bottom: "5vh", width: "40vw", left: "calc(50% - 20vw)" }}>
        <Group sx={{ justifyContent: "center" }}>
            <img src={logo} alt="logo" className={classes.logo}/>
            <Title sx={{ fontFamily: "Ubuntu", textAlign: "center" }} order={3}>Singularity Designs</Title>
        </Group>
        <Center>
            <Text>ad-auth-1.1.0</Text>
        </Center>
    </div>
}
